import { useQuery } from '@tanstack/react-query';
import { getAiFeatureAccess } from '../../core/coursePreferences.js';

/**
 * ml-authz AI feature access for the current course's institution.
 * Returns `{ [feature]: boolean }`. Empty object while loading / on error
 * (treated as allow by callers via `!== false`); use `isLoading` to avoid UI flash.
 *
 * @param {string} courseId
 * @param {boolean} [enabled=true]
 * @returns {{ aiFeatureAccess: Record<string, boolean>, isLoading: boolean }}
 */
export const useAiFeatureAccess = (courseId, enabled = true) => {
  const { data: aiFeatureAccess = {}, isLoading } = useQuery({
    queryKey: ['aiFeatureAccess', courseId],
    queryFn: () => getAiFeatureAccess(courseId),
    enabled: enabled && Boolean(courseId),
    staleTime: 5 * 60 * 1000,
  });

  return { aiFeatureAccess, isLoading };
};
